import { render, staticRenderFns } from "./GemExchangeEditor.vue?vue&type=template&id=5b14e492&scoped=true&"
import script from "./GemExchangeEditor.vue?vue&type=script&lang=js&"
export * from "./GemExchangeEditor.vue?vue&type=script&lang=js&"
import style0 from "./GemExchangeEditor.vue?vue&type=style&index=0&id=5b14e492&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b14e492",
  null
  
)

export default component.exports